import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home"),
    redirect: "/main",
    children: [
      {
        path: "/main",
        name: "Main",
        component: () => import("@/views/Home/content"),
      },
      // {
      //   path: "/product",
      //   name: "Product",
      //   component: () => import("@/views/Product/index"),
      // },
      {
        path: "/joinus",
        name: "Joinus",
        component: () => import("@/views/joinUs/index"),
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/index"),
      },
			{
			  path: "/bcgyl",
			  name: "bcgyl",
			  component: () => import("@/views/download/bcgyl"),
			},
			{
			  path: "/zct",
			  name: "zct",
			  component: () => import("@/views/download/zct"),
			},
			{
			  path: "/jft",
			  name: "jft",
			  component: () => import("@/views/download/jft"),
			},
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
